import React, { useState } from 'react';
import Dashboard from '../../Layouts/Dashboard';
import {
  Box,
  Paper,
  Typography,
  Container,
} from '@mui/material';
import BillingProfileForm from './Blocks/BillingProfileForm';

const ProfilDeFacturation = () => {
  const [successMessage, setSuccessMessage] = useState('');

  // Handle successful profile save
  const handleProfileSaveSuccess = () => {
    setSuccessMessage('Profil de facturation mis à jour avec succès!');
    // Scroll to top or show notification if needed
    window.scrollTo(0, 0);
  };

  return (
    <Dashboard dashboardTitle="Profil de Facturation">
      <Box sx={{ py: 6 }}>
        <Container maxWidth="md">
          <Paper sx={{ p: 4, borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h4" gutterBottom align="center" sx={{ mb: 2 }}>
              Profil de Facturation
            </Typography>
            <Typography variant="subtitle1" align="center" sx={{ mb: 4 }}>
              Veuillez renseigner les informations de votre entreprise ci-dessous.
            </Typography>

            <BillingProfileForm onSaveSuccess={handleProfileSaveSuccess} />
          </Paper>
        </Container>
      </Box>
    </Dashboard>
  );
};

export default ProfilDeFacturation;
